import NarrativeEventContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/NarrativeEventContent";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import TransitionEvent from "../events/TransitionEvent";
import TransitionSoundType from "../sound/TransitionSoundType";

export default class TransitionScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     * @param {AssetLibrary} assetLibrary 
     * @param {SoundManager} soundManager
     * @param {SoundConfig} soundConfig
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, assetLibrary, soundManager, soundConfig) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._assetLibrary = assetLibrary;
        this._soundManager = soundManager;
        this._soundConfig = soundConfig;

        /** @type {NarrativeEventContent} */
        this._content = this.getCustomData().content;
        this._onClose = this.getCustomData().onClose;

        this._bodyTexts = [];
        this._currentBodyTextIndex = 0;
    }

    initialize() {
        super.initialize();

        /** @type Array<string> */
        this._bodyTexts = this._content.getEventDescription()
            .split(TransitionScreenMediator.NEW_PAGE_TAG);

        this._imageContainer = this._target.imageContainer;

        this._target.travelLabelTextField.text = this._languagePack.getText('transition.actionText');

        this._target.locationTextField.text = this._content.getEventName();

        this._handleContinueButtonBound = this._handleContinueButton.bind(this);
        this._continueButton = this.createButton(this._target.continueButton, this._handleContinueButtonBound, this._languagePack.getText(`transition.continueButtonLabel`));

        this._target.bodyTextField.y = this._target.locationTextField.y + this._target.locationTextField.getBounds().height + 40;
        this._setBody(this._bodyTexts[this._currentBodyTextIndex]);

        this._loadBackgroundImage();

        this.preventClickThrough();
    }

    _setBody(bodyText) {
        this._target.bodyTextField.text = this._bodyTexts[this._currentBodyTextIndex];
        this._target.continueButton.y = this._target.bodyTextField.y + this._target.bodyTextField.getBounds().height + 60;
    }

    _handleContinueButton() {
        // Remove click listener so that the player can not spam click the button
        // We add it back again in `_next()` later
        this._continueButton.removeEventListener('click', this._handleContinueButtonBound);

        if (this._currentBodyTextIndex >= this._bodyTexts.length - 1) {
            this._continue();
        } else {
            this._next();
        }
    }

    _loadBackgroundImage() {
        this._imageContainer.removeAllChildren();

        const imageId = this._content.getImage();
        const image = this._assetLibrary.getAsset(this._content.getImage());
        const bitmap = new createjs.Bitmap(image);
        this._imageContainer.addChild(bitmap);

        const backgroungAudioId = this._soundConfig.getSoundId(imageId);
        this._playBackgroundAudio(backgroungAudioId);
    }

    _next() {
        this._currentBodyTextIndex++;

        createjs.Tween.get(this._target.continueButton)
            .to({ alpha: 0 }, 350, createjs.Ease.sineInOut)
            .to({ alpha: 1 }, 350, createjs.Ease.sineInOut)
            .call(() => {
                this._continueButton.addEventListener('click', this._handleContinueButtonBound);
            });

        createjs.Tween.get(this._target.bodyTextField)
            .to({ alpha: 0 }, 350, createjs.Ease.sineInOut)
            .call(() => {
                this._setBody(this._bodyTexts[this._currentBodyTextIndex]);
            })
            .to({ alpha: 1 }, 350, createjs.Ease.sineInOut);
    }

    _continue() {
        this._stopBackgroundAudio();

        this.dispatch(TransitionEvent.CLOSE_REQUEST);
    }
}

TransitionScreenMediator.NEW_PAGE_TAG = "%new_page%";